import { ChakraText, EquipUITheme } from '@equip.health/ui';

interface CalendarErrorProps {
  id: string;
  message: string;
  position?: 'left' | 'center' | 'right';
}

const CalendarError = ({
  id,
  message,
  position = 'left',
}: CalendarErrorProps) => {
  return (
    <ChakraText
      {...EquipUITheme.typography.paragraph}
      color="critical.base"
      id={`${id}-error-message`}
      lineHeight="16.8px"
      textAlign={position}
    >
      {message}
    </ChakraText>
  );
};

export default CalendarError;
